var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c(
      "div",
      { staticClass: "col-6 d-flex flex-row align-items-center mb-2" },
      [
        _c(
          "div",
          { staticClass: "my-auto pr-3" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "regular my-auto text-primary text-capitalize bold client-tooltip",
                attrs: {
                  "data-toggle": "tooltip",
                  "data-original-title": "Go back",
                  to: _vm.backLink,
                },
              },
              [
                _c("span", [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      staticStyle: {
                        "font-size": "1.2em",
                        "padding-top": "0.4em",
                      },
                    },
                    [_vm._v("\n            arrow_back\n          ")]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "h2",
          {
            staticClass:
              "header-title mb-0 d-flex flex-row align-items-center justify-content-start",
          },
          [
            _c("span", { staticClass: "client-name-header" }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6 my-auto" },
      [
        _c("button-bar", {
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row justify-content-end align-items-center",
                    },
                    [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "m-md-2",
                          attrs: {
                            text: _vm.$t("global.words.actions"),
                            variant: "white",
                          },
                        },
                        [
                          _c(
                            "b-dropdown-item",
                            { on: { click: _vm.toViewContacts } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("lists.segments.viewContacts")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { on: { click: _vm.exportContacts } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.exportContactsText) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { on: { click: _vm.toViewDetails } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("global.actions.viewDetails")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "link-class": "text-danger" },
                              on: { click: _vm.showDeleteListModal },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("lists.deleteCurrentList")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentTabIsASegment
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "link-class": "text-danger" },
                                  on: { click: _vm.showDeleteSegmentModal },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("lists.deleteCurrentSegment")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { on: { click: _vm.toImportContacts } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("lists.addContactsToList")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "button-content",
              fn: function () {
                return [
                  _c(
                    "i",
                    { staticClass: "material-icons d-inline d-lg-none" },
                    [_vm._v("more_vert")]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "dropdown-content",
              fn: function () {
                return [
                  _c("b-dropdown-item", { on: { click: _vm.toViewContacts } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lists.segments.viewContacts")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-dropdown-item", { on: { click: _vm.exportContacts } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.exportContactsText) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-dropdown-item", { on: { click: _vm.toViewDetails } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.actions.viewDetails")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "link-class": "text-danger" },
                      on: { click: _vm.showDeleteContactsModal },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("lists.segments.deleteAllContacts")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { on: { click: _vm.toImportContacts } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("lists.addContactsToList")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { on: { click: _vm.showDeleteListModal } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("lists.deleteList")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentTabIsASegment
                    ? _c(
                        "b-dropdown-item",
                        { on: { click: _vm.showDeleteSegmentModal } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("lists.deleteSegment")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("confirm-delete-contacts-modal", {
          ref: "confirmDeleteContactsModal",
          attrs: { "deleting-all-contacts": _vm.deletingAllContacts },
          on: { confirm: _vm.deleteContacts },
        }),
        _vm._v(" "),
        _c("confirm-delete-list-modal", {
          ref: "confirmDeleteListModal",
          attrs: { "deleting-list": _vm.deleteList },
          on: { "delete-list": _vm.handleDeleteList },
        }),
        _vm._v(" "),
        _c("confirm-delete-segment-modal", {
          ref: "confirmDeleteSegmentModal",
          attrs: { "deleting-segment": _vm.deleteSegment },
          on: { "delete-segment": _vm.handleDeleteSegment },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }